import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CTRBMediaHandlerState {
    isOpen: boolean;
    url: string;
    title: string;
    resource_type:string;
    resource_id:string;
}

const initialState: CTRBMediaHandlerState = {
    isOpen: false,
    url: '',
    title: '',
    resource_type: '',
    resource_id: '',
};

const CTRBMediaHandlerSlice = createSlice({
    name: 'CTRBPdfPlayer',
    initialState,
    reducers: {
        setCTRBMediaHandler: (
            state,
            action: PayloadAction<CTRBMediaHandlerState>
        ) => {
            state.isOpen = action.payload.isOpen;
            state.url = action.payload.url;
            state.title = action.payload.title;
            state.resource_id = action.payload.resource_id;
            state.resource_type = action.payload.resource_type;
        },
    },
});

export const { setCTRBMediaHandler } = CTRBMediaHandlerSlice.actions;
export default CTRBMediaHandlerSlice.reducer;
